<template>
    <data-view 
        :tableColumns="tableColumns" 
        :tableData="items" 
        :actionButtons="actionButtons" 
        titleKey="ClientName" 
        @sortChanged="event => emit('sortChanged', event)"
        @loadMore="emit('loadMore')">
    </data-view>
</template>

<script setup>
import { ref } from 'vue'
import DataView from '@/views/app/components/DataView.vue'

const emit = defineEmits(['sortChanged', 'loadMore','edit','changeStatus'])

const props = defineProps({
     items:{ type: Array, default: () => ([]) }
})

const tableColumns = ref([
    { key: 'ClientName', label: 'client', sortable:true}
])

const actionButtons = ref([
    { text: 'edit', icon: 'EditIcon', color: 'warning', permissions:['IU MAIL APPROVED EXPENSES EDIT'], onClick: row => emit('edit', row) },
    { text: 'lock', icon: 'LockIcon', color: 'danger',  permissions:['IU MAIL APPROVED EXPENSES EDIT'], hideIf: row => row.active == '0', onClick: row => emit('changeStatus', {item:row , status:false}) },
    { text: 'unlock', icon: 'UnlockIcon', color: 'success', permissions:['IU MAIL APPROVED EXPENSES EDIT'], hideIf: row => row.active == '1', onClick: row => emit('changeStatus', {item:row , status:true}) },
])

</script>

<style></style>
